// ============================================
// Authentication
// ============================================
export const authEndpoints = {
	login: "/api/auth/login",
	logout: "/api/auth/logout",
	refresh: "/api/auth/refresh",
	me: "/api/auth/me",
} as const;

// ============================================
// Users
// ============================================
export const userEndpoints = {
	list: "/api/users",
	create: "/api/users",
	getById: "/api/users/:id",
	update: "/api/users/:id",
	delete: "/api/users/:id",
} as const;

// ============================================
// Organization Types
// ============================================
export const organizationTypeEndpoints = {
	list: "/api/organization-types",
	create: "/api/organization-types",
	getById: "/api/organization-types/:id",
	update: "/api/organization-types/:id",
	delete: "/api/organization-types/:id",
} as const;

// ============================================
// Organization Type Positions (Lavozimlar)
// ============================================
export const organizationTypePositionEndpoints = {
	list: "/api/organization-type-positions",
	create: "/api/organization-type-positions",
	getById: "/api/organization-type-positions/:id",
	update: "/api/organization-type-positions/:id",
	delete: "/api/organization-type-positions/:id",
} as const;

// ============================================
// Organizations (Tashkilotlar)
// ============================================
export const organizationEndpoints = {
	list: "/api/organization",
	create: "/api/organization",
	getById: "/api/organization/:id",
	update: "/api/organization/:id",
	delete: "/api/organization/:id",
} as const;

// ============================================
// Organization Cross Access (Tashkilotlararo kirish huquqlari)
// ============================================
export const crossAccessEndpoints = {
	list: "/api/organization-cross-access",
	create: "/api/organization-cross-access",
	getById: "/api/organization-cross-access/:id",
	update: "/api/organization-cross-access/:id",
	delete: "/api/organization-cross-access/:id",
} as const;

// ============================================
// SOATO (Hududlar)
// ============================================
export const soatoEndpoints = {
	list: "/api/soato",
} as const;

// ============================================
// Devices (Qurilmalar)
// ============================================
export const deviceEndpoints = {
	list: "/api/devices",
	create: "/api/devices",
	getById: "/api/devices/:id",
	update: "/api/devices/:id",
	delete: "/api/devices/:id",
} as const;

// ============================================
// NVRs (Video yozuvchilar)
// ============================================
export const nvrEndpoints = {
	list: "/api/nvrs",
	create: "/api/nvrs",
	getById: "/api/nvrs/:id",
	update: "/api/nvrs/:id",
	delete: "/api/nvrs/:id",
} as const;

// ============================================
// Cameras (Kameralar)
// ============================================
export const cameraEndpoints = {
	list: "/api/cameras",
	create: "/api/cameras",
	getById: "/api/cameras/:id",
	update: "/api/cameras/:id",
	delete: "/api/cameras/:id",
} as const;

// ============================================
// Staff (Xodimlar)
// ============================================
export const staffEndpoints = {
	list: "/api/staff",
	create: "/api/staff",
	getById: "/api/staff/:id",
	update: "/api/staff/:id",
	delete: "/api/staff/:id",
} as const;

// ============================================
// Students (O'quvchilar)
// ============================================
export const studentEndpoints = {
	list: "/api/students",
	create: "/api/students",
	getById: "/api/students/:id",
	update: "/api/students/:id",
	delete: "/api/students/:id",
	approve: "/api/students/:id/approve",
	bulkApprove: "/api/students/bulk-approve",
	assignClass: "/api/students/assign-class",
} as const;

// ============================================
// Guardians (Ota-onalar)
// ============================================
export const guardianEndpoints = {
	list: "/api/guardians",
	create: "/api/guardians",
	getById: "/api/guardians/:id",
	update: "/api/guardians/:id",
	delete: "/api/guardians/:id",
} as const;

// ============================================
// Class Groups (Sinflar)
// ============================================
export const classGroupEndpoints = {
	list: "/api/class-groups",
	create: "/api/class-groups",
	getById: "/api/class-groups/:id",
	update: "/api/class-groups/:id",
	delete: "/api/class-groups/:id",
} as const;

// ============================================
// File Upload
// ============================================
export const fileEndpoints = {
	upload: "/api/file/upload",
} as const;

// ============================================
// Face Enrollment (Yuz ro'yxatga olish)
// ============================================
export const faceEnrollmentEndpoints = {
	list: "/api/face-enrollment",
	create: "/api/face-enrollment",
	getById: "/api/face-enrollment/:id",
	update: "/api/face-enrollment/:id",
	delete: "/api/face-enrollment/:id",
	studentList: "/api/face-enrollment/students",
	staffList: "/api/face-enrollment/staff",
	reuploadClassGroup: "/api/face-enrollment/reupload-class-group",
	exportUnenrolled: "/api/face-enrollment/unenrolled/export",
} as const;

// ============================================
// Shifts (Smenalar)
// ============================================
export const shiftEndpoints = {
	list: "/api/shifts",
	create: "/api/shifts",
	getById: "/api/shifts/:id",
	update: "/api/shifts/:id",
	delete: "/api/shifts/:id",
} as const;

// ============================================
// Academic Years (O'quv yillari)
// ============================================
export const academicYearEndpoints = {
	list: "/api/academic-years",
	create: "/api/academic-years",
	getById: "/api/academic-years/:id",
	update: "/api/academic-years/:id",
	delete: "/api/academic-years/:id",
} as const;

// ============================================
// Grades (Sinf raqamlari)
// ============================================
export const gradeEndpoints = {
	list: "/api/grades",
	create: "/api/grades",
	getById: "/api/grades/:id",
	update: "/api/grades/:id",
	delete: "/api/grades/:id",
} as const;

// ============================================
// Weekdays (Hafta kunlari)
// ============================================
export const weekdayEndpoints = {
	list: "/api/weekdays",
} as const;

// ============================================
// Staff Workdays (Xodim ish kunlari)
// ============================================
export const staffWorkdayEndpoints = {
	list: "/api/staff-workdays",
	create: "/api/staff-workdays",
	getById: "/api/staff-workdays/:id",
	update: "/api/staff-workdays/:id",
	delete: "/api/staff-workdays/:id",
} as const;

// ============================================
// Health Check
// ============================================
export const healthEndpoints = {
	check: "/api/health",
} as const;

// ============================================
// Daily Attendance (Kunlik Davomat)
// ============================================
export const attendanceEndpoints = {
	list: "/api/daily-attendance",
	create: "/api/daily-attendance",
	getById: "/api/daily-attendance/:id",
	update: "/api/daily-attendance/:id",
	delete: "/api/daily-attendance/:id",
	personEvents: "/api/daily-attendance/person-events",
} as const;

// ============================================
// Lesson Attendance (Dars davomati)
// ============================================
export const lessonAttendanceEndpoints = {
	classDaily: "/api/lesson-attendance/class-daily",
	periodSummary: "/api/lesson-attendance/period-summary",
	studentDetail: "/api/lesson-attendance/student/:id",
} as const;

// ============================================
// Subjects (Fanlar)
// ============================================
export const subjectEndpoints = {
	list: "/api/subjects",
	create: "/api/subjects",
	getById: "/api/subjects/:id",
	update: "/api/subjects/:id",
	delete: "/api/subjects/:id",
} as const;

// ============================================
// Room Types (Xona turlari)
// ============================================
export const roomTypeEndpoints = {
	list: "/api/room-types",
	create: "/api/room-types",
	getById: "/api/room-types/:id",
	update: "/api/room-types/:id",
	delete: "/api/room-types/:id",
} as const;

// ============================================
// Classrooms (Xonalar)
// ============================================
export const classroomEndpoints = {
	list: "/api/classrooms",
	create: "/api/classrooms",
	getById: "/api/classrooms/:id",
	update: "/api/classrooms/:id",
	delete: "/api/classrooms/:id",
} as const;

// ============================================
// Time Slots (Dars soatlari)
// ============================================
export const timeSlotEndpoints = {
	list: "/api/time-slots",
	create: "/api/time-slots",
	getById: "/api/time-slots/:id",
	update: "/api/time-slots/:id",
	delete: "/api/time-slots/:id",
} as const;

// ============================================
// Teacher Subjects (O'qituvchi fanlari)
// ============================================
export const teacherSubjectEndpoints = {
	list: "/api/teacher-subjects",
	create: "/api/teacher-subjects",
	delete: "/api/teacher-subjects/:id",
} as const;

// ============================================
// Teaching Assignments (Dars yuklamalari)
// ============================================
export const teachingAssignmentEndpoints = {
	list: "/api/teaching-assignments",
	create: "/api/teaching-assignments",
	getById: "/api/teaching-assignments/:id",
	update: "/api/teaching-assignments/:id",
	delete: "/api/teaching-assignments/:id",
} as const;

// ============================================
// Schedule Entries (Dars jadvali)
// ============================================
export const scheduleEntryEndpoints = {
	list: "/api/schedule-entries",
	create: "/api/schedule-entries",
	getById: "/api/schedule-entries/:id",
	update: "/api/schedule-entries/:id",
	delete: "/api/schedule-entries/:id",
} as const;

// ============================================
// Trash (Axlat qutisi)
// ============================================
export const trashEndpoints = {
	list: "/api/trash",
	restore: "/api/trash/:model/:id/restore",
	hardDelete: "/api/trash/:model/:id",
} as const;

// ============================================
// Import (Ommaviy import)
// ============================================
export const importEndpoints = {
	bulk: "/api/import/bulk",
	subjects: "/api/import/subjects",
	classrooms: "/api/import/classrooms",
	students: "/api/import/students",
	schedule: "/api/import/schedule",
	teachers: "/api/import/teachers",
} as const;

// ============================================
// Live Stream (Jonli efir)
// ============================================
export const streamEndpoints = {
	/** WebSocket JPEG stream — eski usul, Firefox/Safari fallback uchun */
	live: "/api/stream/live",
	/** HTTP chunked raw H.264/H.265 stream — WebCodecs uchun */
	rawStream: "/api/raw-stream",
} as const;

// ============================================
// Student Excuses (Sababli kelmaganlar)
// ============================================
export const studentExcuseEndpoints = {
	list: "/api/student-excuses",
	create: "/api/student-excuses",
	getById: "/api/student-excuses/:id",
	update: "/api/student-excuses/:id",
	delete: "/api/student-excuses/:id",
} as const;

// ============================================
// Tariffs (Kamera obuna tariflari)
// ============================================
export const tariffEndpoints = {
	list: "/api/tariffs",
	create: "/api/tariffs",
	update: "/api/tariffs/:id",
	delete: "/api/tariffs/:id",
} as const;

// ============================================
// Payments (To'lovlar)
// ============================================
export const paymentEndpoints = {
	list: "/api/payments",
} as const;

// ============================================
// Type Definitions
// ============================================
export type AuthEndpoint = (typeof authEndpoints)[keyof typeof authEndpoints];
export type UserEndpoint = (typeof userEndpoints)[keyof typeof userEndpoints];
export type OrganizationTypeEndpoint =
	(typeof organizationTypeEndpoints)[keyof typeof organizationTypeEndpoints];
export type OrganizationTypePositionEndpoint =
	(typeof organizationTypePositionEndpoints)[keyof typeof organizationTypePositionEndpoints];
export type OrganizationEndpoint =
	(typeof organizationEndpoints)[keyof typeof organizationEndpoints];
export type CrossAccessEndpoint = (typeof crossAccessEndpoints)[keyof typeof crossAccessEndpoints];
export type DeviceEndpoint = (typeof deviceEndpoints)[keyof typeof deviceEndpoints];
export type NvrEndpoint = (typeof nvrEndpoints)[keyof typeof nvrEndpoints];
export type CameraEndpoint = (typeof cameraEndpoints)[keyof typeof cameraEndpoints];
export type StaffEndpoint = (typeof staffEndpoints)[keyof typeof staffEndpoints];
export type StudentEndpoint = (typeof studentEndpoints)[keyof typeof studentEndpoints];
export type GuardianEndpoint = (typeof guardianEndpoints)[keyof typeof guardianEndpoints];
export type ClassGroupEndpoint = (typeof classGroupEndpoints)[keyof typeof classGroupEndpoints];
export type FaceEnrollmentEndpoint =
	(typeof faceEnrollmentEndpoints)[keyof typeof faceEnrollmentEndpoints];
export type SoatoEndpoint = (typeof soatoEndpoints)[keyof typeof soatoEndpoints];
export type FileEndpoint = (typeof fileEndpoints)[keyof typeof fileEndpoints];
export type HealthEndpoint = (typeof healthEndpoints)[keyof typeof healthEndpoints];
export type AttendanceEndpoint = (typeof attendanceEndpoints)[keyof typeof attendanceEndpoints];
export type LessonAttendanceEndpoint =
	(typeof lessonAttendanceEndpoints)[keyof typeof lessonAttendanceEndpoints];
export type ShiftEndpoint = (typeof shiftEndpoints)[keyof typeof shiftEndpoints];
export type AcademicYearEndpoint =
	(typeof academicYearEndpoints)[keyof typeof academicYearEndpoints];
export type GradeEndpoint = (typeof gradeEndpoints)[keyof typeof gradeEndpoints];
export type WeekdayEndpoint = (typeof weekdayEndpoints)[keyof typeof weekdayEndpoints];
export type StaffWorkdayEndpoint =
	(typeof staffWorkdayEndpoints)[keyof typeof staffWorkdayEndpoints];
export type SubjectEndpoint = (typeof subjectEndpoints)[keyof typeof subjectEndpoints];
export type RoomTypeEndpoint = (typeof roomTypeEndpoints)[keyof typeof roomTypeEndpoints];
export type ClassroomEndpoint = (typeof classroomEndpoints)[keyof typeof classroomEndpoints];
export type TimeSlotEndpoint = (typeof timeSlotEndpoints)[keyof typeof timeSlotEndpoints];
export type TeacherSubjectEndpoint =
	(typeof teacherSubjectEndpoints)[keyof typeof teacherSubjectEndpoints];
export type TeachingAssignmentEndpoint =
	(typeof teachingAssignmentEndpoints)[keyof typeof teachingAssignmentEndpoints];
export type ScheduleEntryEndpoint =
	(typeof scheduleEntryEndpoints)[keyof typeof scheduleEntryEndpoints];
export type TrashEndpoint = (typeof trashEndpoints)[keyof typeof trashEndpoints];
export type ImportEndpoint = (typeof importEndpoints)[keyof typeof importEndpoints];
export type StudentExcuseEndpoint =
	(typeof studentExcuseEndpoints)[keyof typeof studentExcuseEndpoints];
export type TariffEndpoint = (typeof tariffEndpoints)[keyof typeof tariffEndpoints];
export type PaymentEndpoint = (typeof paymentEndpoints)[keyof typeof paymentEndpoints];

export type ApiEndpoint =
	| AuthEndpoint
	| UserEndpoint
	| OrganizationTypeEndpoint
	| OrganizationTypePositionEndpoint
	| OrganizationEndpoint
	| CrossAccessEndpoint
	| DeviceEndpoint
	| StaffEndpoint
	| StudentEndpoint
	| GuardianEndpoint
	| ClassGroupEndpoint
	| FaceEnrollmentEndpoint
	| SoatoEndpoint
	| FileEndpoint
	| HealthEndpoint
	| AttendanceEndpoint
	| LessonAttendanceEndpoint
	| ShiftEndpoint
	| AcademicYearEndpoint
	| GradeEndpoint
	| WeekdayEndpoint
	| StaffWorkdayEndpoint
	| SubjectEndpoint
	| RoomTypeEndpoint
	| ClassroomEndpoint
	| TimeSlotEndpoint
	| TeacherSubjectEndpoint
	| TeachingAssignmentEndpoint
	| NvrEndpoint
	| CameraEndpoint
	| ScheduleEntryEndpoint
	| TrashEndpoint
	| ImportEndpoint
	| StudentExcuseEndpoint
	| TariffEndpoint
	| PaymentEndpoint;

// ============================================
// Helper Functions
// ============================================

/**
 * Endpoint URL dagi path parametrlarini almashtirish
 * @example replaceParams("/api/users/:id", { id: "123" }) => "/api/users/123"
 */
export function replaceParams(endpoint: string, params: Record<string, string>): string {
	let url = endpoint;

	for (const [key, value] of Object.entries(params)) {
		url = url.replace(`:${key}`, encodeURIComponent(value));
	}

	return url;
}
